<template>
  <div :class="cls" :title="symbolName">
    <OrderMark v-if="isShowMark" :is-main-order="isMAIN" />
    <span class="text-tip">
      {{ symbolName }}
    </span>
  </div>
</template>
<script>
import { SEC_TYPE } from 'const/stock'
import { ORDER_TYPE } from 'const/trade'
import OrderMark from 'mod/OrderMark'
export default {
  name: 'StockNameWithMark',
  components: {
    OrderMark
  },
  props: {
    order: Object
  },
  computed: {
    cls() {
      return this.isShowMark ? ['symbol'] : ['symbol', 'no-mark']
    },
    isMAIN() {
      return this.order.attachType === ORDER_TYPE.MAIN
    },
    isShowMark() {
      if (this.isMAIN) { return this.order.profitTakerOrderId || this.order.stopLossOrderId }
      return this.order.parentId
    },
    symbolName() {
      if (this.order.secType === SEC_TYPE.OPT) {
        return this.$options.filters.formatOptionName(this.order, 2)
      }
      return this.order.nameCN
    }
  }
}
</script>
